<template>
  <v-navigation-drawer
    v-model="$store.state.toggle.showSidebar"
    app
    width="310"
    class="hide-md-and-up header-mobile"
    style="z-index: 999"
  >
    <v-list class="pt-5">
      <v-list-item>
        <icon name="logo" height="40" width="109" />
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="pb-1">
          <strong
            v-show="user.id"
            style="cursor: pointer"
            class="black--text mt-4"
            @click="$router.push({ name: 'profile' }).catch((err) => {})"
          >
            <AvatarComponent size="36" class="mr-1" isMine />
            {{ user.firstName }}
            {{ user.lastName }}
          </strong>
        </v-list-item-content>
      </v-list-item>

      <v-list-group
        no-action
        v-for='item in items'
        :key="item.text"
        :append-icon="item.child ? '$expand' : ''"
        v-model="item.active"
      >
        <v-list-item slot='activator' :to="{ name: item.route }">
            <v-list-item-title class="text-capitalize">{{ item.text }}</v-list-item-title>
        </v-list-item>
        <v-list-item class="pl-2" v-if="item.child">
          <v-list-item-content>
            <v-expansion-panels flat accordion v-model="panel">
              <router-link
                :to="{ name: 'ranking-worldwide', params: { top: 10 } }"
                class="v-expansion-panel-header rounded-0 font-weight-bold"
                style="border-bottom: 1px solid rgba(0, 0, 0, 0.125);"
                :class="[
                  $route.name === 'ranking-worldwide'
                  ? 'primary--text' : 'black--text'
                ]"
                v-translate
              >Worldwide</router-link>
              <v-expansion-panel
                v-for="(dataArea, idx) in item.child.slice(1, item.child.length)" :key="idx"
              >
                <v-expansion-panel-header :style="`border-bottom: 1px solid rgba(0,0,0,0.125)`" class="rounded-0 font-weight-bold">
                  <router-link
                    text plain
                    :to="{
                      name: 'ranking-zone',
                      params: {
                        top: 10,
                        zone: dataArea.slug,
                        zoneName: dataArea.slug
                      }
                    }"
                    :class="[
                      $route.name === 'ranking-zone'
                      && $route.params.zone === dataArea.slug
                      ? 'primary--text' : 'black--text'
                    ]"
                  >{{dataArea.name}}</router-link>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <AreaHover :dataArea="dataArea"/>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

    </v-list>

    <v-list v-if="token" class="pt-0">
      <v-divider class="my-1"></v-divider>

      <v-list-item dense class="pointer">
        <v-list-item-icon class="mr-2" style="width: 30px">
          <v-icon size="16" class="ml-1">fas fa-user-gear</v-icon>
        </v-list-item-icon>
        <v-list-item-content
          class="elevation-0 subtitle-2"
          @click="$router.push({ name: 'profile' }).catch((err) => {})"
        >
          <translate>Manage my profile</translate>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        dense
        class="pointer"
        v-for="course in user.courseAdmin"
        :key="course.id"
        v-if="course.status == 'accepted'"
      >
        <v-list-item-icon class="mr-4">
          <v-icon size="16" class="ml-1">fas fa-gears</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="elevation-0 subtitle-2">
          <router-link
            :to="{name: 'courses.home', params: {coursesCountry: course.country.slug, namegolf: course.slug}}"
            replace
            class="dark--text"
          >
            {{ `${$gettext("Manage")} ${course.name}` }}
          </router-link>
        </v-list-item-content>
      </v-list-item>

      <v-list-item dense class="pointer">
        <v-list-item-icon class="mr-2" style="width: 30px">
          <v-icon size="16" class="ml-1">fas fa-arrow-right-from-bracket</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="elevation-0 subtitle-2" @click="logout">
          <translate>Logout</translate>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import AreaHover from '@/components/HomePage/AreaHover.vue';
import { mapState } from "vuex";
export default {
  name: "HeaderMobile",
  components: { AreaHover },
  data() {
    return {
      panel: null
    }
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
    }),
    zoneAndCountry() {
      return this.$store.state.golfcourse
              .availableZoneAndCountry;
    },
    items() {
      return [
        {
          text: this.$gettext("News feed"),
          route: "newsfeed",
        },
        {
          text: this.$gettext("About"),
          route: "aboutUs",
        },
        {
          text: this.$gettext("Golf courses"),
          child: this.zoneAndCountry
        },
        {
          text: this.$gettext("Vloggers/Coaches"),
          route: "coaches",
        },
        {
          text: this.$gettext("Player Finder"),
          route: "player-finder",
        },
        {
          text: this.$gettext("Community"),
          route: "community",
        },
      ];
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout")
    },
  },
  watch: {
    $route:  {
      handler(val) {

        if(!['ranking-zone', 'ranking-country', 'ranking-worldwide'].includes(val.name)) {
          this.items.map((item)=>item.active=false)
          this.panel = null
        }
      }
    }
  }
};
</script>

<style lang="scss">
  .header-mobile {
    .v-list-item--active {
      &:before {
        opacity: 0 !important;
      }
    }
  }
</style>